module.exports = __webpack_public_path__ + "static/media/coupon_campaign_icon.e7a1351d.png";